<template>
    <div class="page">
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="订单号">
                <el-input v-model="queryForm.orderId" placeholder="请填写订单号" style="width: 200px" clearable></el-input>
            </el-form-item>
            <el-form-item label="来源">
                <el-select placeholder="请选择来源" clearable v-model="queryForm.source" style="width: 200px">
                    <el-option v-for="item in sourceList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                    style="width: 360px"
                    v-model="timeRange"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 0px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group" style="display: flex; align-items: center;">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-refresh"
                        :loading="updateLoading"
                        @click="openUpdateDialog"
                    >更新备付金</el-button>
                    <div class="balance-box">
                        <span class="balance-label">余额：</span>
                        <span class="balance-value">{{ balance }}</span>
                    </div>
                </div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                :data="fundHisList"
                width="100%"
                row-key="id"
                size="small"
                height="100%"
                v-loading="loading"
            >
                <el-table-column :show-overflow-tooltip="true" align="center" prop="order_id" label="订单号"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="merchant_id" label="平台商户">
                    <template slot-scope="scope">
                        {{ getMerchantName(scope.row.merchant_id) }}   
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="operate_type" label="操作类型">
                    <template slot-scope="scope">
                        {{ getOperateType(scope.row.operate_type) }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="money" label="变更金额"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="new_money" label="变更后余额"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="old_money" label="变更前余额"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="create_time" label="创建时间"> </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>

        <el-dialog
            title="更新备付金"
            :visible.sync="showUpdateDialog"
            width="450px"
            :close-on-click-modal="false"
            @close="closeUpdateDialog"
        >
            <el-form
                :model="updateForm"
                ref="updateFormRef"
                label-width="100px"
                size="small"
            >
                <el-form-item label="金额" prop="money" :rules="[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { type: 'number', min: 0.01, message: '金额必须大于0', trigger: 'blur' }
                ]">
                    <el-input
                        v-model.number="updateForm.money"
                        type="number"
                        placeholder="请输入金额"
                        style="width: 280px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="平台" prop="merchantId" :rules="[
                    { required: true, message: '请选择平台', trigger: 'blur' }
                ]">
                    <el-select
                        v-model="updateForm.merchantId"
                        placeholder="请选择平台"
                        style="width: 280px"
                    >
                        <el-option
                            v-for="item in merchantList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型" prop="operateType" :rules="[
                    { required: true, message: '请选择操作类型', trigger: 'blur' }
                ]">
                    <el-select
                        v-model="updateForm.operateType"
                        placeholder="请选择操作类型"
                        style="width: 280px"
                    >
                        <el-option
                            v-for="item in operateTypeList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeUpdateDialog">取消</el-button>
                <el-button
                    size="small"
                    type="primary"
                    :loading="updateLoading"
                    @click="submitUpdate"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, postJson } from '@/utils/request.js';

export default {
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            timeRange: [],
            queryForm: {
                orderId: '',
                source: '',
                startTime: '',
                endTime: ''
            },
            sourceList: [
                { key: 'ONLINE', value: '线上' },
                { key: 'OFFLINE', value: '线下' }
            ],
            merchantList: [
                { key: '001', value: '墨焰' }
            ],
            operateTypeList: [
                { key: 1, value: '充值' },
                { key: -1, value: '扣减' }
            ],
            updateForm: {
                money: '',
                merchantId: '',
                operateType: ''
            },
            loading: false,
            updateLoading: false,
            isSearch: true,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            fundHisList: [],
            balance: '0',
            showUpdateDialog: false
        };
    },
    created() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const formatDateTime = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        this.timeRange = [formatDateTime(today), formatDateTime(now)];
        this.queryForm.startTime = formatDateTime(today);
        this.queryForm.endTime = formatDateTime(now);
        this.getFundHisList();
        this.getFund();
    },
    methods: {
        getMerchantName(merchantId) {
            const item = this.merchantList.find((s) => s.key === merchantId);
            return item ? item.value : merchantId;
        },
        getOperateType(operateType) {
            const item = this.operateTypeList.find((s) => s.key === operateType);
            return item ? item.value : operateType;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetDialog() {
            this.queryForm = {
                orderId: '',
                source: '',
                startTime: '',
                endTime: ''
            };
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const formatDateTime = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };
            this.timeRange = [formatDateTime(today), formatDateTime(now)];
            this.queryForm.startTime = formatDateTime(today);
            this.queryForm.endTime = formatDateTime(now);
            this.currentPage = 1;
            this.getFundHisList();
        },
        getSourceLabel(source) {
            const item = this.sourceList.find((s) => s.key === source);
            return item ? item.value : source;
        },
        refreshList() {
            this.getFundHisList();
        },
        searchList() {
            this.currentPage = 1;
            this.getFundHisList();
        },
        // 列表
        getFundHisList() {
            if (this.timeRange && this.timeRange.length) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            } else {
                this.queryForm.startTime = '';
                this.queryForm.endTime = '';
            }
            this.loading = true;
            postJson('/php/moyan/getbfjlog', {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.fundHisList = res.page.data || [];
                    this.totalNum = res.page.total || 0;
                } else {
                    this.fundHisList = [];
                    this.totalNum = 0;
                }
            }).catch(() => {
                this.loading = false;
                this.fundHisList = [];
                this.totalNum = 0;
            });
            // get('/manage/platform/fund/queryFundHis', {
            //     ...this.queryForm,
            //     pageNum: this.currentPage,
            //     pageSize: this.pageSize
            // }).then((res) => {
            //     this.loading = false;
            //     if (res.code == 200) {
            //         this.fundHisList = res.data.records || [];
            //         this.totalNum = res.data.total || 0;
            //     } else {
            //         this.fundHisList = [];
            //         this.totalNum = 0;
            //     }
            // }).catch(() => {
            //     this.loading = false;
            //     this.fundHisList = [];
            //     this.totalNum = 0;
            // });
        },
        // 获取余额
        getFund() {
            postJson('/php/moyan/getbfj').then((res) => {
                if (res.code == 200) {
                    this.balance = res.data.money || '0';
                } else {
                    this.$message({
                        message: res.msg || '查询失败',
                        type: 'error',
                        duration: 2000
                    });
                    this.balance = '0';
                }
            }).catch(() => {
                this.$message({
                    message: '查询失败',
                    type: 'error',
                    duration: 2000
                });
                this.balance = '0';
            });
            // get('/manage/platform/fund/queryFund').then((res) => {
            //     if (res.code == 200) {
            //         this.balance = res.data[0]?.money || '0';
            //     } else {
            //         this.$message({
            //             message: res.msg || '查询失败',
            //             type: 'error',
            //             duration: 2000
            //         });
            //         this.balance = '0';
            //     }
            // }).catch(() => {
            //     this.$message({
            //         message: '查询失败',
            //         type: 'error',
            //         duration: 2000
            //     });
            //     this.balance = '0';
            // });
        },
        openUpdateDialog() {
            this.updateForm = {
                money: '',
                merchantId: '',
                operateType: ''
            };
            this.showUpdateDialog = true;
        },
        closeUpdateDialog() {
            this.showUpdateDialog = false;
            this.updateForm = {
                money: '',
                merchantId: '',
                operateType: ''
            };
        },
        // 更新备付金
        submitUpdate() {
            this.$refs.updateFormRef.validate((valid) => {
                if (valid) {
                    this.updateLoading = true;
                    postJson('/php/moyan/addbfj', {
                        money: this.updateForm.money,
                        merchantId: this.updateForm.merchantId,
                        operateType: this.updateForm.operateType,
                        userId: localStorage.getItem('userId')
                    }).then((res) => {
                        this.updateLoading = false;
                        if (res.code == 200) {
                            this.$message({
                                message: res.message || '更新成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.showUpdateDialog = false;
                            this.getFund();
                            this.getFundHisList();
                        } else {
                            this.$message({
                                message: res.message || '更新失败',
                                type: 'error',
                                duration: 2000
                            });
                        }
                    }).catch(() => {
                        this.updateLoading = false;
                        this.$message({
                            message: '更新失败',
                            type: 'error',
                            duration: 2000
                        });
                    });
                    // postJson('/manage/platform/fund/updateReserveFund', {
                    //     money: this.updateForm.money,
                    //     merchantId: this.updateForm.merchantId,
                    //     operateType: this.updateForm.operateType,
                    //     userId: localStorage.getItem('userId')
                    // }).then((res) => {
                    //     this.updateLoading = false;
                    //     if (res.code == 200) {
                    //         this.$message({
                    //             message: res.message || '更新成功',
                    //             type: 'success',
                    //             duration: 2000
                    //         });
                    //         this.showUpdateDialog = false;
                    //         this.getFund();
                    //         this.getFundHisList();
                    //     } else {
                    //         this.$message({
                    //             message: res.message || '更新失败',
                    //             type: 'error',
                    //             duration: 2000
                    //         });
                    //     }
                    // }).catch(() => {
                    //     this.updateLoading = false;
                    //     this.$message({
                    //         message: '更新失败',
                    //         type: 'error',
                    //         duration: 2000
                    //     });
                    // });
                }
            });
        },
        currentChange(page) {
            this.currentPage = page;
            this.getFundHisList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.getFundHisList();
        }
    }
};
</script>

<style lang="scss" scoped>
.balance-box {
    display: flex;
    align-items: center;
    margin-left: 15px;
    padding: 0 12px;
    height: 32px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #f5f7fa;
    font-size: 13px;
    .balance-label {
        color: #606266;
    }
    .balance-value {
        color: #f56c6c;
        font-weight: 600;
        margin-left: 4px;
    }
}
.pagination-box {
    display: flex;
    justify-content: flex-end;
    padding: 12px 0;
}
</style>
